import { useCallback } from 'react';
import { FileDropzone, FileAttachmentCard } from '@/components/common';
import { useTranslations } from '@/hooks';
import { openFile } from '@/lib/utils';
import {
  DECLARATION_FILE_ACCEPT,
  MAX_DECLARATION_FILES,
} from '../constants/declarations.constants';
import styles from './UploadStep.module.scss';

/**
 * Props:
 *   files         the picked files
 *   onFilesAdded  (files) => void
 *   onRemoveFile  (file) => void
 */
export const UploadStep = ({ files, onFilesAdded, onRemoveFile }) => {
  const t = useTranslations();
  const handleView = useCallback((file) => openFile(file.file), []);
  const handleRemove = useCallback((file) => onRemoveFile(file.id), [onRemoveFile]);

  return (
    <FileDropzone
      fileCount={files.length}
      maxFiles={MAX_DECLARATION_FILES}
      accept={DECLARATION_FILE_ACCEPT}
      title={t('DECLARATIONS_SELECT_FILES_TITLE')}
      subtitle={t('DECLARATIONS_SELECT_FILES_SUBTITLE')}
      uploadLabel={t('FORM_UPLOAD_FILES')}
      helperText={t('DECLARATIONS_UPLOAD_HELPER', {
        max: MAX_DECLARATION_FILES,
        format: DECLARATION_FILE_ACCEPT,
      })}
      onFilesAdded={onFilesAdded}
    >
      {files.length > 0 && (
        <div className={styles.grid}>
          {files.map((file) => (
            <FileAttachmentCard
              key={file.id}
              file={file}
              bordered={false}
              onView={handleView}
              onRemove={handleRemove}
            />
          ))}
        </div>
      )}
    </FileDropzone>
  );
};
